import styles from "./toggleSwitch.module.css";

const ToggleSwitch = (props) => {
  return (
    <div
      className={styles.container}
      style={{ backgroundColor: props.value ? "#cdffda" : "" }}
      onClick={props.onClick}
    >
      <div
        className={`${styles.circle} ${props.value ? styles.circle_on : ""}`}
      ></div>
      {props.onHoverTxt && <p>{props.onHoverTxt}</p>}
    </div>
  );
};

export default ToggleSwitch;
